export default __webpack_public_path__ + "media/images/meals/noon-65d8c9cbcd45953179deb982a26fd738.png";